import axios from 'axios';
import {
   USER_LOGIN_FAIL,
   USER_LOGIN_REQUEST,
   USER_LOGIN_SUCCESS,
   USER_LOGOUT,
   USER_DETAILS_FAIL,
   USER_DETAILS_REQUEST,
   USER_DETAILS_SUCCESS,
   USER_DETAILS_RESET,
   USER_TENANT_ACCESS_FAIL,
   USER_TENANT_ACCESS_REQUEST,
   USER_TENANT_ACCESS_SUCCESS,
   USER_TENANT_ACCESS_RESET,
   USER_TENANCY_REGISTER_FAIL,
   USER_TENANCY_REGISTER_REQUEST,
   USER_TENANCY_REGISTER_SUCCESS,

   USER_UPDATE_TENANCY_PROFILE_FAIL,
   USER_UPDATE_TENANCY_PROFILE_REQUEST,
   USER_UPDATE_TENANCY_PROFILE_SUCCESS,

   USER_TENANCY_PROFILE_DETAILS_FAIL,
   USER_TENANCY_PROFILE_DETAILS_REQUEST,
   USER_TENANCY_PROFILE_DETAILS_SUCCESS,
   USER_TENANCY_PROFILE_DETAILS_RESET,
   TENANT_DASHBOARD_DETAILS_FAIL,
   TENANT_DASHBOARD_DETAILS_REQUEST,
   TENANT_DASHBOARD_DETAILS_SUCCESS,
   TENANT_DASHBOARD_DETAILS_RESET,
   USER_TENANT_CREATE_REQUEST,
   USER_TENANT_CREATE_SUCCESS,
   USER_TENANT_CREATE_FAIL,
   USER_TENANT_LIST_REQUEST,
   USER_TENANT_LIST_SUCCESS,
   USER_TENANT_LIST_FAIL,
   TENANT_ANALYTICS_REQUEST,
   TENANT_ANALYTICS_SUCCESS,
   TENANT_ANALYTICS_FAIL,
   TENANT_LOGO_UPLOAD_REQUEST,
   TENANT_LOGO_UPLOAD_SUCCESS,
   TENANT_LOGO_UPLOAD_FAIL,
   SECONDARY_LOGO_UPLOAD_REQUEST,
   SECONDARY_LOGO_UPLOAD_SUCCESS,
   SECONDARY_LOGO_UPLOAD_FAIL,
   USER_PERMISSION_UPDATE_REQUEST,
   USER_PERMISSION_UPDATE_SUCCESS,
    USER_PERMISSION_UPDATE_FAIL,
    USER_SUSPEND_REQUEST,
    USER_SUSPEND_SUCCESS,
     USER_SUSPEND_FAIL,
     USER_PASSWORD_RESET_REQUEST,
     USER_PASSWORD_RESET_SUCCESS,
     USER_PASSWORD_RESET_FAIL,
     USER_PASSWORD_CHANGE_REQUEST,
     USER_PASSWORD_CHANGE_SUCCESS,
     USER_PASSWORD_CHANGE_FAIL,
 } from '../constants/userConstants.js';
// import moment from 'moment';
import url2 from '../utils/baseUrl.js'
import { extractRequestErrorMessage } from '../utils/requestErrors.js';
// require('dotenv').config()


let url = url2;

const readTenantIdFromStorage = () => {
   try {
      const rawTenant = localStorage.getItem('tenant');
      if (!rawTenant) {
         return '';
      }

      const parsedTenant = JSON.parse(rawTenant);
      return parsedTenant?.singleTenant?._id || '';
   } catch {
      return '';
   }
};

const clearPersistedDemandGenerationCaches = () => {
    localStorage.removeItem('demand_Specificlists');
    localStorage.removeItem('demand_lists');
};

const clearPersistedImportUploadSessions = () => {
   try {
      Object.keys(localStorage)
         .filter((key) => key.startsWith('billable:external-bill-upload:'))
         .forEach((key) => localStorage.removeItem(key));
   } catch {
      // Ignore storage access failures.
   }
};

const clearPersistedTenantScopedCaches = () => {
   clearPersistedDemandGenerationCaches();
   clearPersistedImportUploadSessions();
};

const clearPersistedTenantSelection = () => {
   localStorage.removeItem('tenant');
   clearPersistedTenantScopedCaches();
};

const clearPersistedTenantContext = () => {
   localStorage.removeItem('userInfoTenancy');
   clearPersistedTenantSelection();
};

const pruneInvalidStoredTenantSelection = (tenancyPayload) => {
   const storedTenantId = readTenantIdFromStorage();
   if (!storedTenantId) {
      return false;
   }

   const allowedTenants = Array.isArray(tenancyPayload?.myTenants) ? tenancyPayload.myTenants : [];
   const stillAllowed = allowedTenants.some((tenantItem) => String(tenantItem?._id || '') === String(storedTenantId));

   if (!stillAllowed) {
      clearPersistedTenantSelection();
      return true;
   }

   return false;
};

const resolveTenantId = (getState, explicitTenantId) => {
   if (explicitTenantId) {
      return explicitTenantId;
   }

   const {
      tenantDashboardDetails: { tenant } = {},
      userLogin: { userInfo } = {}
   } = getState();

   return (
      tenant?.singleTenant?._id
      || readTenantIdFromStorage()
      || userInfo?.tenantId
      || ''
   );
};

const buildTenantHeaders = (getState, extraHeaders = {}, explicitTenantId) => {
   const tenantId = resolveTenantId(getState, explicitTenantId);

   if (!tenantId) {
      throw new Error('Please select tenancy first');
   }

   return {
      ...extraHeaders,
      tenantid: tenantId,
      tenantId
   };
};

//  let url = "";

// if (process.env.NODE_ENV === 'production'){
//   url = process.env.REACT_APP_BASE_URL
//  console.log("production")
// }else {
//    url = process.env.REACT_APP_DEV
//    console.log("development")
// }

export const login = (email, password) => async (dispatch) => {
   try {
      dispatch({
         type: USER_LOGIN_REQUEST
      });

      const normalizedEmail = String(email || '').trim().toLowerCase();

      const config = {
         headers: {
            'Content-Type': 'application/json',

         }
      };


      const { data } = await axios.post(`${url}/users/login`,
         { email: normalizedEmail, password },
         config);

      clearPersistedTenantContext();
      dispatch({ type: USER_TENANT_ACCESS_RESET });
      dispatch({ type: TENANT_DASHBOARD_DETAILS_RESET });
      dispatch({ type: USER_TENANCY_PROFILE_DETAILS_RESET });

      dispatch({
         type: USER_LOGIN_SUCCESS,
         payload: data
      });

      localStorage.setItem('userInfo', JSON.stringify(data));


   } catch (error) {
      dispatch({
         type: USER_LOGIN_FAIL,
         payload:
            error.response && error.response.data.message
               ? error.response.data.message
               : error.message
      });
   }
};


export const getUserDetails = () => async (dispatch, getState) => {
   try {
      dispatch({
         type: USER_DETAILS_REQUEST
      });

      const { userLogin: { userInfo } } = getState();


      const config = {
         headers: {
            Authorization: `Bearer ${userInfo.accessToken}`
         }
      };
      // const url = 'https://billable-dev.herokuapp.com'

      const { data } = await axios.get(`${url}/users/myprofile`, config);

      const refreshedUserInfo = {
         ...userInfo,
         ...data,
         accessToken: userInfo?.accessToken,
      };

      dispatch({
         type: USER_DETAILS_SUCCESS,
         payload: refreshedUserInfo
      });

      dispatch({
         type: USER_LOGIN_SUCCESS,
         payload: refreshedUserInfo
      });

      localStorage.setItem('userInfo', JSON.stringify(refreshedUserInfo));
   } catch (error) {
      const message =
         error.response && error.response.data.message
            ? error.response.data.message
            : error.message;
      if (message === 'Not authorized, token failed') {
         dispatch(logout());
      }
      dispatch({
         type: USER_DETAILS_FAIL,
         payload: message
      });
   }
};

export const getTenantAccessAction = (explicitTenantId) => async (dispatch, getState) => {
   try {
      dispatch({ type: USER_TENANT_ACCESS_REQUEST });

      const { userLogin: { userInfo } } = getState();
      const tenantId = resolveTenantId(getState, explicitTenantId);

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               Authorization: `Bearer ${userInfo.accessToken}`
            }, tenantId)
         }
      };

      const { data } = await axios.get(`${url}/users/access/me`, config);

      dispatch({
         type: USER_TENANT_ACCESS_SUCCESS,
         payload: data?.data || null,
      });

      return data?.data || null;
   } catch (error) {
      const message =
         error.response && error.response.data.message
            ? error.response.data.message
            : error.message;

      dispatch({
         type: USER_TENANT_ACCESS_FAIL,
         payload: message,
      });

      throw error;
   }
};
export const getTenantDashboardDetails = (id) => async (dispatch, getState) => {
   try {
      dispatch({
         type: TENANT_DASHBOARD_DETAILS_REQUEST
      });

      const { userLogin: { userInfo } } = getState();


      const config = {
         headers: {
            Authorization: `Bearer ${userInfo.accessToken}`
         }
      };
      // const url = 'https://billable-dev.herokuapp.com'

      const { data } = await axios.get(`${url}/tenants/t/${id}`, config);
      //    const { data } = await axios.get(`/users/dashboard/${id}`, config);
      //    console.log(JSON.stringify(data) + '2++++++2');
      //    console.log(JSON.stringify(data) + '++++++')
      //    console.log(JSON.stringify(data) + '++++++')
      dispatch({
         type: TENANT_DASHBOARD_DETAILS_SUCCESS,
         payload: data
      });

      localStorage.setItem('tenant', JSON.stringify(data));

      return data;
   } catch (error) {
      const message =
         error.response && error.response.data.message
            ? error.response.data.message
            : error.message;
      if (message === 'Not authorized, token failed') {
         dispatch(logout());
      }
      dispatch({
         type: TENANT_DASHBOARD_DETAILS_FAIL,
         payload: message
      });
      throw error;
   }
};

export const switchTenantContextAction = (tenantId) => async (dispatch, getState) => {
   const normalizedTenantId = String(tenantId || '').trim();
   if (!normalizedTenantId) {
      throw new Error('Please select tenancy first');
   }

   const { userLogin: { userInfo } } = getState();

   const tenantConfig = {
      headers: {
         Authorization: `Bearer ${userInfo.accessToken}`
      }
   };

   const accessConfig = {
      headers: {
         ...buildTenantHeaders(getState, {
            Authorization: `Bearer ${userInfo.accessToken}`
         }, normalizedTenantId)
      }
   };

   const [tenantResponse, accessResponse] = await Promise.all([
      axios.get(`${url}/tenants/t/${normalizedTenantId}`, tenantConfig),
      axios.get(`${url}/users/access/me`, accessConfig),
   ]);

   const tenantData = tenantResponse.data;
   const accessData = accessResponse.data?.data || null;

   dispatch({
      type: TENANT_DASHBOARD_DETAILS_SUCCESS,
      payload: tenantData,
   });

   dispatch({
      type: USER_TENANT_ACCESS_SUCCESS,
      payload: accessData,
   });

   localStorage.setItem('tenant', JSON.stringify(tenantData));

   return {
      tenant: tenantData,
      access: accessData,
   };
};

export const getUserTenancyDetails = () => async (dispatch, getState) => {
   try {
      dispatch({
         type: USER_TENANCY_PROFILE_DETAILS_REQUEST
      });

      const { userLogin: { userInfo } } = getState();

      const config = {
         headers: {
            Authorization: `Bearer ${userInfo.accessToken}`
            //  tenantId : `${userInfo._id}`

         }
      };
      // const url = 'https://billable-dev.herokuapp.com'

      const { data } = await axios.get(`${url}/tenants/myprofiles`, config);
      const removedInvalidTenant = pruneInvalidStoredTenantSelection(data);
      if (removedInvalidTenant) {
         dispatch({ type: USER_TENANT_ACCESS_RESET });
         dispatch({ type: TENANT_DASHBOARD_DETAILS_RESET });
      }

      dispatch({
         type: USER_TENANCY_PROFILE_DETAILS_SUCCESS,
         payload: data
      });

      localStorage.setItem('userInfoTenancy', JSON.stringify(data));


   } catch (error) {
      const message =
         error.response && error.response.data.message
            ? error.response.data.message
            : error.message;
      if (message === 'Not authorized, token failed') {
         dispatch(logout());
      }
      dispatch({
         type: USER_TENANCY_PROFILE_DETAILS_FAIL,
         payload: message
      });
   }
};


export const registerTenancy = (ownerEmail, ownerFirstName, ownerLastName, ownerPassword, tenantName, tenantAbout) => async (dispatch) => {
   try {
      dispatch({
         type: USER_TENANCY_REGISTER_REQUEST,
      })

      const config = {
         headers: {
            'Content-Type': 'application/json',
         },
      }

      const { data } = await axios.post(
         `${url}/tenants`,
         { ownerEmail, ownerFirstName, ownerLastName, ownerPassword, tenantName, tenantAbout },
         config
      )

      dispatch({
         type: USER_TENANCY_REGISTER_SUCCESS,
         payload: data,
      })

      //   dispatch({
      //     type: USER_LOGIN_SUCCESS,
      //     payload: data,
      //   })

      //   localStorage.setItem('userInfo', JSON.stringify(data))
   } catch (error) {
      dispatch({
         type: USER_TENANCY_REGISTER_FAIL,
         payload:
            error.response && error.response.data.message
               ? error.response.data.message
               : error.message,
      })
   }
}



















export const updateUserProfileMe = (user) => async (dispatch, getState) => {
   try {
      dispatch({
         type: USER_UPDATE_TENANCY_PROFILE_REQUEST,
      })

      const {
         userLogin: { userInfo },
      } = getState()

      const config = {
         headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`,
         },
      }

      const { data } = await axios.put(`/api/users/profile`, user, config)

      dispatch({
         type: USER_UPDATE_TENANCY_PROFILE_SUCCESS,
         payload: data,
      })
      // dispatch({
      //   type: USER_LOGIN_SUCCESS,
      //   payload: data,
      // })
      // localStorage.setItem('userInfo', JSON.stringify(data))
   } catch (error) {
      const message =
         error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      if (message === 'Not authorized, token failed') {
         dispatch(logout())
      }
      dispatch({
         type: USER_UPDATE_TENANCY_PROFILE_FAIL,
         payload: message,
      })
   }
}




export const userTenantCreateAction =
   (firstName, lastName, email, password, role = 'ADMIN', permissions = undefined, assignedLgaKeys = []) =>
      async (dispatch, getState) => {
         try {
            const { userTenantCreate = {} } = getState();
            if (userTenantCreate.loading) {
               return;
            }

            dispatch({ type: USER_TENANT_CREATE_REQUEST });
            const {
               userLogin: { userInfo }
            } = getState();
            const normalizedEmail = String(email || '').trim().toLowerCase();

            const config = {
               headers: {
                  ...buildTenantHeaders(getState, {
                     'Content-Type': 'application/json',
                     Authorization: `Bearer ${userInfo.accessToken}`
                  })
               }
            };

            const { data } = await axios.post(
               `${url}/users/admin`,
               {
                  firstName: String(firstName || '').trim(),
                  lastName: String(lastName || '').trim(),
                  email: normalizedEmail,
                  // Optional: without it the user sets their own password from the welcome email.
                  ...(password ? { password } : {}),
                  role,
                  permissions,
                  assignedLgaKeys
               },
               config
            );

            dispatch({
               type: USER_TENANT_CREATE_SUCCESS,
               payload: data
            });
         } catch (error) {
            dispatch({
               type: USER_TENANT_CREATE_FAIL,
               payload: extractRequestErrorMessage(error, 'Failed to create user')
            });
         }
      };





/**
 * Get tenant analytics for dashboard
 * @param {string} tenantId - The tenant ID
 */
export const getTenantAnalytics = (tenantId, filters = {}) => async (dispatch, getState) => {
   try {
      dispatch({ type: TENANT_ANALYTICS_REQUEST });

      const { userLogin: { userInfo } } = getState();
      const resolvedTenantId = resolveTenantId(getState, tenantId);

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               Authorization: `Bearer ${userInfo.accessToken}`
            }, resolvedTenantId)
         }
      };

      const params = new URLSearchParams();
      if (filters.fromDate) params.append('fromDate', filters.fromDate);
      if (filters.toDate) params.append('toDate', filters.toDate);

      const querySuffix = params.toString() ? `?${params.toString()}` : '';
      const { data } = await axios.get(`${url}/tenants/analytics${querySuffix}`, config);

      dispatch({
         type: TENANT_ANALYTICS_SUCCESS,
         payload: data.data
      });
   } catch (error) {
      dispatch({
         type: TENANT_ANALYTICS_FAIL,
         payload:
            error.response && error.response.data.message
               ? error.response.data.message
               : error.message
      });
   }
};

/**
 * Upload tenant logo
 * @param {File} file - The logo file to upload
 */
export const uploadTenantLogo = (file) => async (dispatch, getState) => {
   try {
      dispatch({ type: TENANT_LOGO_UPLOAD_REQUEST });

      const { userLogin: { userInfo } } = getState();
      const tenantId = resolveTenantId(getState);

      const formData = new FormData();
      formData.append('file', file);

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               Authorization: `Bearer ${userInfo.accessToken}`
            }, tenantId)
         }
      };

      const { data } = await axios.post(`${url}/tenants/setlogo`, formData, config);

      dispatch({
         type: TENANT_LOGO_UPLOAD_SUCCESS,
         payload: data
      });

      dispatch({
         type: TENANT_DASHBOARD_DETAILS_SUCCESS,
         payload: { singleTenant: data }
      });
      localStorage.setItem('tenant', JSON.stringify({ singleTenant: data }));

      return data;
   } catch (error) {
      const message = extractRequestErrorMessage(error, 'Failed to upload logo');
      dispatch({
         type: TENANT_LOGO_UPLOAD_FAIL,
         payload: message
      });
      throw new Error(message);
   }
};

/**
 * Upload secondary logo (displayed on right side of demand notice header)
 * @param {File} file - The logo file to upload
 */
export const uploadSecondaryLogo = (file) => async (dispatch, getState) => {
   try {
      dispatch({ type: SECONDARY_LOGO_UPLOAD_REQUEST });

      const { userLogin: { userInfo } } = getState();

      const formData = new FormData();
      formData.append('file', file);

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               Authorization: `Bearer ${userInfo.accessToken}`
            })
         }
      };

      const { data } = await axios.post(`${url}/tenants/secondarylogo`, formData, config);

      dispatch({
         type: SECONDARY_LOGO_UPLOAD_SUCCESS,
         payload: data
      });

      return data;
   } catch (error) {
      const message = extractRequestErrorMessage(error, 'Failed to upload secondary logo');
      dispatch({
         type: SECONDARY_LOGO_UPLOAD_FAIL,
         payload: message
      });
      throw new Error(message);
   }
};

export const updateDemandNoticeSignatory = ({ file, name, title, removeImage = false }) => async (dispatch, getState) => {
   try {
      const { userLogin: { userInfo } } = getState();

      const formData = new FormData();
      if (file) {
         formData.append('file', file);
      }
      if (name !== undefined) {
         formData.append('name', name);
      }
      if (title !== undefined) {
         formData.append('title', title);
      }
      if (removeImage) {
         formData.append('removeImage', 'true');
      }

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               Authorization: `Bearer ${userInfo.accessToken}`,
            })
         }
      };

      const { data } = await axios.put(`${url}/tenants/settings/demand-notice-signatory`, formData, config);
      return data;
   } catch (error) {
      throw new Error(extractRequestErrorMessage(error, 'Failed to update the demand notice signatory.'));
   }
};

/**
 * Update tenant settings (template customization)
 */
export const updateTenantSettings = (settings) => async (dispatch, getState) => {
   try {
      const { userLogin: { userInfo } } = getState();
      const tenantId = resolveTenantId(getState);

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${userInfo.accessToken}`
            }, tenantId)
         }
      };

      const { data } = await axios.put(`${url}/tenants/settings`, settings, config);

      // Refresh tenant details to get updated settings
      dispatch(getTenantDashboardDetails(tenantId)).catch(() => undefined);

      return data;
   } catch (error) {
      throw error.response?.data?.message || error.message;
   }
};

/**
 * Get tenant settings
 */
export const getTenantSettings = (options = {}) => async (dispatch, getState) => {
   try {
      const { userLogin: { userInfo } } = getState();
      const params = {};

      if (options.freshnessToken) {
         params.v = options.freshnessToken;
      }
      params.assetMode = 'browser';

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${userInfo.accessToken}`
            })
         },
         params
      };

      const { data } = await axios.get(`${url}/tenants/settings`, config);
      return data;
   } catch (error) {
      throw error.response?.data?.message || error.message;
   }
};

export const logout = () => (dispatch) => {
   localStorage.removeItem('userInfo');
   clearPersistedTenantContext();

   dispatch({ type: USER_LOGOUT });
   dispatch({ type: USER_DETAILS_RESET });
   dispatch({ type: USER_TENANT_ACCESS_RESET });

   // dispatch({ type: USER_LIST_RESET });
   document.location.href = '/';
};

/**
 * List all users for the current tenant
 */
export const listTenantUsers = (params = {}) => async (dispatch, getState) => {
   try {
      dispatch({ type: USER_TENANT_LIST_REQUEST });

      const { userLogin: { userInfo } } = getState();

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               Authorization: `Bearer ${userInfo.accessToken}`
            })
         }
      };

      const query = new URLSearchParams();
      if (params.page) query.append('page', String(params.page));
      if (params.limit) query.append('limit', String(params.limit));
      if (params.search) query.append('search', String(params.search));

      const querySuffix = query.toString() ? `?${query.toString()}` : '';
      const { data } = await axios.get(`${url}/users/tenant/users${querySuffix}`, config);

      dispatch({
         type: USER_TENANT_LIST_SUCCESS,
         payload: {
            data: data.data || [],
            pagination: data.pagination
         }
      });
   } catch (error) {
      dispatch({
         type: USER_TENANT_LIST_FAIL,
         payload:
            error.response && error.response.data.message
               ? error.response.data.message
               : error.message
      });
   }
};

/**
 * Update user permissions
 * @param {string} userId - ID of the user to update
 * @param {object} permissions - Permissions object e.g. { canEditDemandNotice: true }
 */
export const updateUserPermissionsAction = (userId, permissions) => async (dispatch, getState) => {
   try {
      dispatch({ type: USER_PERMISSION_UPDATE_REQUEST });

      const { userLogin: { userInfo } } = getState();

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${userInfo.accessToken}`
            })
         }
      };

      const { data } = await axios.patch(
         `${url}/users/${userId}/permissions`,
         permissions,
         config
      );

      dispatch({
         type: USER_PERMISSION_UPDATE_SUCCESS,
         payload: data.data
      });

      return data;
   } catch (error) {
      dispatch({
         type: USER_PERMISSION_UPDATE_FAIL,
         payload:
            error.response && error.response.data.message
               ? error.response.data.message
               : error.message
      });
      throw error;
   }
};

/**
 * Suspend or activate a user
 * @param {string} userId - ID of the user to suspend/activate
 * @param {boolean} isActive - New active status
 */
export const suspendUserAction = (userId, isActive) => async (dispatch, getState) => {
   try {
      dispatch({ type: USER_SUSPEND_REQUEST });

      const { userLogin: { userInfo } } = getState();

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${userInfo.accessToken}`
            })
         }
      };

      const { data } = await axios.patch(
         `${url}/users/${userId}/status`,
         { isActive },
         config
      );

      dispatch({
         type: USER_SUSPEND_SUCCESS,
         payload: data.data
      });

      return data;
   } catch (error) {
      dispatch({
         type: USER_SUSPEND_FAIL,
         payload:
            error.response && error.response.data.message
               ? error.response.data.message
               : error.message
      });
      throw error;
   }
};

/**
 * Reset a field agent's password
 * @param {string} userId - ID of the field agent
 * @param {string} newPassword - New password to set
 */
export const resetFieldAgentPasswordAction = (userId, newPassword) => async (dispatch, getState) => {
   try {
      dispatch({ type: USER_PASSWORD_RESET_REQUEST });

      const { userLogin: { userInfo } } = getState();

      const config = {
         headers: {
            ...buildTenantHeaders(getState, {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${userInfo.accessToken}`
            })
         }
      };

      const { data } = await axios.patch(
         `${url}/users/${userId}/password`,
         { newPassword },
         config
      );

      dispatch({
         type: USER_PASSWORD_RESET_SUCCESS,
         payload: data.data
      });

      return data;
   } catch (error) {
      dispatch({
         type: USER_PASSWORD_RESET_FAIL,
         payload:
            error.response && error.response.data.message
               ? error.response.data.message
               : error.message
      });
      throw error;
   }
};

export const changePasswordAction = (currentPassword, newPassword) => async (dispatch, getState) => {
   try {
      dispatch({ type: USER_PASSWORD_CHANGE_REQUEST });

      const { userLogin: { userInfo } } = getState();
      const headers = {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${userInfo.accessToken}`
      };
      // Platform users belong to no tenant; the tenant header only labels the audit entry.
      const tenantId = resolveTenantId(getState);
      const config = { headers: tenantId ? { ...headers, tenantid: tenantId, tenantId } : headers };

      const { data } = await axios.patch(
         `${url}/users/change-password`,
         { currentPassword, newPassword },
         config
      );

      dispatch({
         type: USER_PASSWORD_CHANGE_SUCCESS,
         payload: data,
      });

      return data;
   } catch (error) {
      const message = extractRequestErrorMessage(error, 'Failed to change password');
      dispatch({
         type: USER_PASSWORD_CHANGE_FAIL,
         payload: message,
      });
      throw new Error(message);
   }
};

// Public password recovery calls: no Authorization or tenant headers.
export const requestPasswordResetEmail = async (email) => {
   const { data } = await axios.post(`${url}/users/forgot-password`, { email });
   return data;
};

export const validatePasswordResetToken = async (token) => {
   const { data } = await axios.get(`${url}/users/validate-reset-token`, { params: { token } });
   return data;
};

export const resetPasswordWithToken = async (token, newPassword) => {
   const { data } = await axios.post(`${url}/users/reset-password`, { token, newPassword });
   return data;
};
